import styles from "../../assets/css/remittance.new-rate-compare.module.scss";
import AppSkeleton from "../../skeletons/AppSkeleton";

const RateCardSkeleton = ({ isDark }) => {
  const baseColor = isDark ? "#1b2047" : "";
  const highlightColor = isDark ? "#040721" : "";

  return (
    <div className={styles.skeleton}>
      <div className={styles.providerInfo}>
        <div>
          <AppSkeleton
            height={42}
            width={42}
            baseColor={baseColor}
            highlightColor={highlightColor}
            variant="rounded"
            className={styles.rounded}
          />
        </div>
        <div className={styles.providerName}>
          <AppSkeleton
            height={21}
            width={60}
            baseColor={baseColor}
            highlightColor={highlightColor}
          />
          <AppSkeleton
            height={10}
            width={30}
            baseColor={baseColor}
            highlightColor={highlightColor}
          />
        </div>
      </div>
      <div>
        <div>
          <AppSkeleton
            height={40}
            width={"calc(100vw - 93.5px)"}
            baseColor={baseColor}
            highlightColor={highlightColor}
          />
        </div>
        <div>
          {" "}
          <AppSkeleton
            height={40}
            width={"calc(100vw - 93.5px)"}
            baseColor={baseColor}
            highlightColor={highlightColor}
          />
        </div>
        <div>
          {" "}
          <AppSkeleton
            height={40}
            width={"calc(100vw - 93.5px)"}
            baseColor={baseColor}
            highlightColor={highlightColor}
          />
        </div>
      </div>
    </div>
  );
};
export default RateCardSkeleton;
